export const MOBILE_LAYOUT_ID = 'mobile-layout';
export const MOBILE_LAYOUT_GNB_ID = 'mobile-layout-gnb';
